import React, { useEffect, useState } from "react";

// framework and libarry
import { Row, Col, Card, Form, Table, Button, Badge } from "react-bootstrap";
import moment from "moment";
import { useLazyQuery, useMutation } from "@apollo/client";
import "../../../styles/claimTable.css";

// components
import { COLOR_TEXT, COLOR_WHITE } from "../../../constants";
import { CREATE_INVOICE_CREDIT } from "../../../graphql/wallet/mutation";
import ModalConfirmComponent from "../../../components/ModalConfirmComponent";
import LoadingSpinner from "../../../components/LoadingSpinner";
import CurrentDateModal from "../../../components/currentComponent/CurrentDateModal";
import { convertCurrentDate, convertStatusInvoiceClaim, convertStatusPaid, numberFormat, splitDateTime } from "../../../helpers";
// import { formatPrice } from '../../../helpers';

//  icons 
import { MdAdd, MdDateRange } from "react-icons/md";
import _ from "lodash";
import EmptyCredit from "./EmptyCredit";
import { GET_TRANSACTIONS } from "../../../graphql/wallet/query";
import PaginationHelper from "../../../helpers/PaginationHelper";



export default function HistoryClaims() {
 
  const [selectedItems, setSelectedItems] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [remark, setRemark] = useState()
  let _shopId = localStorage.getItem("SHOP");
  const [historyDatas, setHistoryDatas] = useState([])
  const [activeButton, setActiveButton] = useState("thisMonth");


  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  const [creditDatas, setCreditDatas] = useState({
    data: [],
    chartDatas: [],
    total: 0,
    credited: 0,
    receivedMoney: 0,
  });
  const [cdFillter, setCdFillter] = useState({
    createdAt_gte: "",
    createdAt_lt: "",
  });
  const [paymentMethod, setPaymentMethod] = useState({
    origin: '',
    status: '',
  })

  // apollo client libarry
  const [createInvoiceCredit, { loading: loadingCreateCredit }] = useMutation(
    CREATE_INVOICE_CREDIT
  );
  const [
    getAllTransactions,
    { data: transactionData, loading: loadingTransaction },
  ] = useLazyQuery(GET_TRANSACTIONS, { fetchPolicy: "cache-and-network" });


  // useEffect Hook
  useEffect(() => {
    if (transactionData) {
      setCreditDatas({
        data: transactionData?.getAllTransactions?.data,
        total: transactionData?.getAllTransactions?.total,
        credited: transactionData?.getAllTransactions?.reports?.credited,
        receivedMoney: transactionData?.getAllTransactions?.reports?.receivedMoney,
        totalPaidCompleted: transactionData?.getAllTransactions?.reports?.totalPaidCompleted,
        chartDatas: transactionData?.getAllTransactions?.reports?.chartDatas
      });
    }
  }, [transactionData]);
  useEffect(() => {
    if (creditDatas?.chartDatas) {

      const _newDatas = creditDatas?.chartDatas.filter((data) => data?.billStatus === "APPROVED")
      setHistoryDatas(_newDatas)

    }
  }, [creditDatas?.chartDatas]);

  useEffect(() => {
    fetchTransactions();
}, [paymentMethod, cdFillter, _skip, remark]);

 // function and logic this component
 const fetchTransactions = async () => {
  try {
    let shopId = localStorage.getItem("SHOP");

    if (loadingTransaction) return;
    let _where = {
      shopId: shopId, // "657fbca4741fcb028ebeec3f",
      // status: 'PAYMENT_COMPLETED'
    }

    // is origin or payment method
    if (!_.isEmpty(paymentMethod?.origin)) {
      _where = {
        ..._where,
        origin: paymentMethod?.origin,
      }
    }

    // is remark
    if (!_.isEmpty(remark)) {
      _where = {
        ..._where,
        remark: remark,
      }
    }
    // is status
    if (!_.isEmpty(paymentMethod?.status)) {
      _where = {
        ..._where,
        status: paymentMethod?.status,
      }
    }
    // is current date
    if (!_.isEmpty(cdFillter)) {
      let startDateComponents = splitDateTime(cdFillter?.createdAt_gte);
      let endDateComponents = splitDateTime(cdFillter?.createdAt_lt);
      _where = {
        ..._where,
        createdAt_gte: startDateComponents,
        createdAt_lt: endDateComponents,
      }
    }

    await getAllTransactions({
      variables: {
        where: _where,
        skip: (_skip - 1) * _limit,
        limit: _limit,
      },
    });
    // setCdFillter({
    //   createdAt_gte: '', createdAt_lt: ''
    // })
  } catch (error) {
    console.log(error);
  }
};


  // create invoice crediting
  const handleCreateInvoiceCredit = async () => {
    try {
      if (loadingCreateCredit) return;
      await createInvoiceCredit({
        variables: {
          data: {
            payments: JSON.stringify(selectedItems),
            shopId: _shopId, // "657fbca4741fcb028ebeec3f"
          },
        },
      });
      setShowConfirm(false);
      setSelectedItems([]);
    } catch (error) {
      console.log("error:", error);
    }
  };

  // Handle select all
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allCompletedItems = creditDatas?.data.filter(item => item?.status === 'PAYMENT_COMPLETED' && item?.billStatus !== "REQUESTING") || [];
      setSelectedItems(allCompletedItems);
    } else {
      setSelectedItems([]);
    }
  };

  // Handle select single
  const handleSelectSingle = (event, item) => {
    if (event.target.checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((selectedItem) => selectedItem._id !== item._id)
      );
    }
  };


  // select payment method
  const onSelectPaymentMethod = (e) => {
    let _values = e?.target?.value;
    setPaymentMethod({
      origin: _values
    });
  };


  // select origin
  const onSelectStatusPayment = (e) => {
    let _values = e?.target?.value;
    setPaymentMethod({
      status: _values
    });
  };

  return (
    <>
      <Row>
        <Col md={8}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>ຊອກຫາລະຫັດອໍເດີ້</Form.Label>
            <Form.Control value={remark} type="text" onChange={(e) => setRemark(e?.target?.value)} placeholder="ORD-000-00000" />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>ວັນທີ,ເດືອນ,ປີ</Form.Label>
            <Button
              variant="outline-secondary"
              onClick={() => setIsCurrentModals(true)}
              style={{ width: "100%", maxWidth: 230, display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}

            >
              <MdDateRange style={{ fontSize: 25, color: COLOR_TEXT }} />
              {cdFillter?.createdAt_gte === "" && cdFillter?.createdAt_lt === "" ? (
                "mm/dd/yyyy"
              ) : (
                <>
                  {convertCurrentDate(cdFillter?.createdAt_gte) + "-" + convertCurrentDate(cdFillter?.createdAt_lt)}
                </>
              )}
            </Button>
          </Form.Group>
        </Col>
      </Row>

      <Card
        className="mb-4"
        style={{ boxShadow: "none", background: COLOR_WHITE }}
      >
        <Card.Body>
          <Card.Title>
            <Row>
              <Col><h5>ລາຍການທີ່ເຄມແລ້ວ {historyDatas?.length ?? 0}</h5></Col>
              <Col style={{ textAlign: "right" }}>

              </Col>
            </Row>
          </Card.Title>
          {loadingTransaction ? (
            <LoadingSpinner />
          ) : (
            <>
              <div className="claim-responsive-table">
                <Table>
                  <thead style={{ borderBottom: "none" }}>
                    <tr>
                      <th>
                        ລຳດັບ
                      </th>
                      <th>ລະຫັດອໍເດີ້</th>
                      <th>ຈຳນວນເງິນ</th>
                      <th>ທະນາຄານ</th>
                      <th>ວັນທີ,ເດືອນ,ປີ</th>
                      <th>ສະຖານະບິນ</th>
                      <th>ໝາຍເຫດ</th>
                    </tr>
                  </thead>
                  <tbody>

                    {historyDatas?.length > 0 ? (

                      <>
                        {historyDatas.map((item, index) => (
                          <tr
                            key={index + 1 + _limit * (_skip - 1)}
                            // style={{
                            //   background: item?.bill !== null || item?.billStatus === "REQUESTING"
                            //     ? "#f1f1f1"
                            //     : item?.billStatus === "REQUESTING"
                            //       ? "#fff"
                            //       : "#fff",
                            // }}
                          >
                            <td>
                              {index + 1 + _limit * (_skip - 1)}
                            </td>
                            <td>
                              {item?.remark ?? "-"}
                            </td>
                            <td>{numberFormat(item?.amount) ?? 0}</td>
                            <td>{item?.origin ?? "-"}</td>
                            {/* <td>-</td> */}
                            <td>
                              {moment(item?.createdAt).format("DD/MM/YYYY : HH:mm")}
                            </td>
                            <td>
                              {item?.bill !== null || item?.billStatus === "APPROVED" ? (
                                <h5><Badge
                                  pill
                                  bg="success"
                                >
                                  ເຄລມເງີິນສຳເລັດ
                                </Badge></h5>
                              ) : (
                                <h5>
                                  <Badge
                                    pill
                                    bg={
                                      item?.status === "PAYMENT_COMPLETED"
                                        ? "success"
                                        : item?.status === "CLOSED"
                                          ? "danger"
                                          : "light"
                                    }
                                  >
                                    {convertStatusPaid(item?.status)}
                                  </Badge>
                                </h5>
                              )}
                            </td>
                            <td></td>
                            {/* <td>
                              {_.isEmpty(item?.isClaim) ? (
                                <h5>
                                  <Badge pill bg="primary">ຍັງບໍ່ເຄມ</Badge>
                                </h5>
                              ) : (
                                <h5>
                                  {item?.isClaim === "CREATED" ? (
                                    <Badge pill bg="warning">ລໍຖ້າດຳເນີນການ</Badge> // ສ້າງ ຂໍເຄມສຳເລັດ
                                  ) : item?.isClaim === "FINISHED" ? (
                                    <Badge pill bg="success">ສຳເລັດທຸລະກຳ</Badge>
                                  ) : item?.isClaim === "APPROVING" ? (
                                    <Badge pill bg="info">ກຳລັງອະນຸມັດ</Badge> // ກຳລັງດຳເນີນການ
                                  ) : (
                                    <Badge pill bg="danger">ກະລຸນາກວດສອບ</Badge>
                                  )}
                                </h5>
                              )}
                            </td> */}
                          </tr>
                        ))}
                      </>

                    ) : (
                      <>
                        <EmptyCredit colSpan={7} />
                      </>
                    )}
                  </tbody>

                </Table>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {creditDatas?.total > 0 &&
                  Pagination_helper(creditDatas?.total, "/wallet_store", ``)}
              </div>
            </>
          )}
        </Card.Body>
      </Card >

      {/* modeal confirm create */}
      < ModalConfirmComponent
        showConfirmModal={showConfirm}
        handleCancel={() => setShowConfirm(false)
        }
        loadingConfirm={loadingCreateCredit}
        handleConfirm={handleCreateInvoiceCredit}
        title="ຢືນຢັນ ເພື່ອໃຫ້ແນ່ໃຈ!"
        text="ທ່ານຕ້ອງການສ້າງ ໃບແຈ້ງຖອນໃນຄັ້ງນີ້ແທ້ບໍ!"
      />

      {/* modal current date  */}
      < CurrentDateModal
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setCdFillter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
      />
    </>
  );
}
